import React, { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col'
import { base_url, auth_headers } from '../http-auth-data'

const DesiredSystemSelect = (props) => {
    const [hvac_select, setHvacSelect] = useState([]);
    const [dataReceived, setDataReceived] = useState(false);
    
    useEffect(() => {
        fetch(base_url + "/index.php?cmd=systems&type=" + 
        props.system_type +
        "&combined_dhw=" + props.combined_dhw +
        "&heat_both=" + props.heat_both, {
            credentials: "include",
            headers: auth_headers
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setHvacSelect(result.hvac_select);
                    setDataReceived(true);
                },
                (error) => {
                    console.log(error)
                }
            )
    }, [props.system_type, props.combined_dhw, props.heat_both]);

    if (!dataReceived) {
        return (<Col>Loading...</Col>)
    }
    var label = "Initialise values with:"
    var select_values = hvac_select

    return (
        <Form.Group controlId={`desired_system.${props.system_type}`}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                as="select"
                custom
                value={props.selected_system}
                disabled={props.disabled}
                onChange={(e) => { props.changeFunc(e, props.system_type) }}
            >
                <option key="0" value="0" >Current system</option>
                {select_values.map(value => {
                    return <option key={value.id} value={value.id}>{value.description}</option>
                })}
            </Form.Control>
        </Form.Group>
    );
}

export default DesiredSystemSelect
